import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { flatMap, join } from 'lodash';
import { map } from 'rxjs/operators';
@Injectable({
  providedIn: 'root',
})
export class UserRegionService extends ApiService {
  constructor(public http: HttpClient) {
    super(http);
  }

  baseUri = 'socrates/authz/api';
  authzViewsUri = 'socrates/authz/api/views';

  public getByUserId(userId: string): Observable<UserRegion[]> {
    return this.http.get<UserRegion[]>(this.endpoint(this.baseUri, `users/${userId}/userregions`));
  }

  public getByUserRegionViewUserIds(userIds: string[]): Observable<UserRegion[]> {
    userIds = userIds.map((a) => `'${a}'`);
    return this.http
      .get<UsersResponse[]>(
        this.endpoint(
          `${this.baseUri}/users?$select=guid&$expand=UserRegions($select=RegionId;$expand=Region($select=name))&$filter=guid in (${join(userIds, ',')})`
        )
      )
      .pipe(
        map((userResponses: UsersResponse[]): UserRegion[] =>
          flatMap(
            userResponses.map((userResponse: UsersResponse) =>
              userResponse.userRegions.map(
                (region: UserRegionsExpandRegion) =>
                  ({
                    userId: userResponse?.guid,
                    regionId: region?.regionId,
                    regionName: region?.region?.name,
                  } as UserRegion)
              )
            )
          )
        )
      );
  }

  public getMunicipalitiesByRegionId(regionId: string): Observable<UserRegionMunicipalitites[]> {
    return this.http.get<UserRegionMunicipalitites[]>(
      this.endpoint(this.baseUri, `regions/${regionId}/municipalities?$expand=municipality($select=name, municipalityKey)&select=municipality`)
    );
  }

  public getMunicipalitiesByRegionIdDirect(regionId: string): Observable<UserRegionMunicipalitites[]> {
    return this.http.get<UserRegionMunicipalitites[]>(this.directEndpoint('api', 'regions', regionId, 'municipalities'));
  }

  public post(userRegion: any): Observable<UserRegion> {
    return this.http.post<UserRegion>(this.endpoint(this.baseUri, `users/${userRegion.userId}/regions/${userRegion.regionId}`), userRegion);
  }

  public delete(userRegion: any): Observable<UserRegion> {
    return this.http.delete<UserRegion>(this.endpoint(this.baseUri, `users/${userRegion.userId}/regions/${userRegion.regionId}`));
  }
}

interface UsersResponse {
  guid: string;
  userRegions: UserRegionsExpandRegion[];
}

interface UserRegionsExpandRegion {
  region: { name: string };
  regionId: string;
}

export interface UserRegion {
  guid: string;
  userId: string;
  regionId: string;
  regionName: string;
  creationDate: Date;
  modifyDate: Date;
  modifyUser: string;
}
export interface UserRegionMunicipalitites {
  municipality: RegionMunicipality;
  regionId: string;
}

export interface RegionMunicipality {
  name: string;
  municipalityKey: string;
}
